// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__lAbjm","modal":"Modal_modal__FnsJn","slide-down":"Modal_slide-down__z1hUK"};